<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  data-test="copy-treatments-dialog"
>
  <p class="text--body">{{ 'copyStandardDescription' | translate }}</p>
  <div class="flex--gutter-container">
    <!-- Crop select -->
    <div class="flex--row">
      <mat-form-field class="flex__child">
        <mat-label>{{ 'crop' | translate }}</mat-label>

        <input
          type="text"
          placeholder="{{ 'crop' | translate }}"
          matInput
          formControlName="cropId"
          [matAutocomplete]="cropAutoComplete"
          #cropInput
          data-test="copy-treatments-cropFilter"
        />
        <mat-autocomplete
          #cropAutoComplete="matAutocomplete"
          data-test="copy-treatments-crop-options"
          [displayWith]="displayCrop()"
        >
          @for (option of filteredCrops | async; track option.id) {
            <mat-option [value]="option.id" data-test="copy-treatments-crop-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Crop years select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'cropYears' | translate }}</mat-label>
        <mat-select formControlName="cropYears" multiple data-test="copy-treatments-yearFilter">
          @for (cropYear of data.cropYears; track cropYear) {
            <mat-option [value]="cropYear">
              {{ cropYear }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Select all schemas & treatments -->
    <div class="flex--row mat-checkbox-row-wrapper">
      <div class="col-5">
        <mat-checkbox
          color="primary"
          formControlName="selectAllTreatmentsAndSchema"
          data-test="copy-treatments-selectAll"
          (change)="selectSchemasAndTreatments($event.checked)"
        >
          {{ 'selectSchemasTreatments' | translate }}
        </mat-checkbox>
      </div>
    </div>

    <!-- Soil types select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'soilTypes' | translate }}</mat-label>
        <mat-select formControlName="soilTypeIds" multiple data-test="copy-treatments-soilFilter">
          @for (soilType of data.soilTypes; track soilType.id) {
            <mat-option [value]="soilType.id">
              {{ soilType.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Provinces select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'province' | translate }}</mat-label>
        <mat-select formControlName="province" multiple data-test="copy-treatments-provinceFilter">
          @for (province of provinces; track province) {
            <mat-option [value]="province">
              {{ province }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Skal select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'skal' | translate }}</mat-label>
        <mat-select formControlName="isSkalOptions" multiple data-test="copy-treatments-skalFilter">
          @for (option of booleanOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.key }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- PlanetProof select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'planetProof' | translate }}</mat-label>
        <mat-select
          formControlName="isPlanetProofOptions"
          multiple
          data-test="copy-treatments-planetproofFilter"
        >
          @for (option of booleanOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.key }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Ground water preservation select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'groundWaterPreservation' | translate }}</mat-label>
        <mat-select
          formControlName="isGroundWaterPreservationOptions"
          multiple
          data-test="copy-treatments-groundwaterFilter"
        >
          @for (option of booleanOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.key }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Schemas select -->
    <div class="flex--row">
      <mat-form-field class="col-5">
        <mat-label>{{ 'schemas' | translate }}</mat-label>
        <mat-select formControlName="schemaIds" multiple data-test="copy-treatments-schemasFilter">
          @for (schema of data.treatmentSchemas; track schema.id) {
            <mat-option [value]="schema.id" [disabled]="isSchemaForbiddenForPlanetProof(schema.id)">
              {{ schema.name }}
              @if (isSchemaForbiddenForPlanetProof(schema.id)) {
                {{ ' - ' + ('treatmentForbiddenInPlanetProof' | translate) }}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Treatments select -->
    <div class="flex--row">
      <mat-form-field class="flex__child">
        <mat-label>{{ 'treatments' | translate }}</mat-label>
        <mat-select
          formControlName="treatmentIds"
          multiple
          data-test="copy-treatments-treatmentsFilter"
        >
          @for (treatment of data.treatments; track treatment.id) {
            <mat-option
              [value]="treatment.id"
              [disabled]="
                isInSelectedSchema(treatment.id) || isForbiddenForPlanetProof(treatment.id)
              "
            >
              {{ treatment.name }} - {{ 'period' | translate }}
              {{ getSalesOrderPeriod(data.salesOrderPeriods, treatment.periodId).name }} -
              {{ treatment.objective | translate }}
              @if (isForbiddenForPlanetProof(treatment.id)) {
                {{ ' - ' + ('treatmentForbiddenInPlanetProof' | translate) }}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
